import common from '../common';

export default {
  jpath: ['video'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
